let FoundryLifecycle = {};


FoundryLifecycle = (function () {
    const VALID_TABS = new Set(['moon-fuse-panel', 'moon-dream-panel']);
    const visibilitySubscribers = new Set();
    const tabSubscribers = new Set();
    let active = false;
    let activeTab = 'moon-fuse-panel';

    function notify(subscribers, ...args) {
        subscribers.forEach((subscriber) => {
            try {
                subscriber(...args);
            } catch (error) {
                console.error('[Foundry] Surface lifecycle subscriber failed:', error);
            }
        });
    }

    function setActive(nextActive) {
        const normalized = nextActive === true;
        if (normalized === active) return;
        active = normalized;
        notify(visibilitySubscribers, active);
    }

    function setActiveTab(nextTab) {
        if (!VALID_TABS.has(nextTab)) {
            throw new Error(`Unknown Foundry tab: ${String(nextTab)}`);
        }
        if (nextTab === activeTab) return;
        const previousTab = activeTab;
        activeTab = nextTab;
        notify(tabSubscribers, activeTab, previousTab);
    }

    function subscribeTo(subscribers, subscriber) {
        if (typeof subscriber !== 'function') return () => {};
        subscribers.add(subscriber);
        return () => subscribers.delete(subscriber);
    }

    return {
        isActive() {
            return active;
        },
        getActiveTab() {
            return activeTab;
        },
        isTabActive(tabId) {
            return active && activeTab === tabId;
        },
        setActive,
        setActiveTab,
        subscribe(subscriber) {
            return subscribeTo(visibilitySubscribers, subscriber);
        },
        subscribeTab(subscriber) {
            return subscribeTo(tabSubscribers, subscriber);
        },
    };
})();

export { FoundryLifecycle };
